export default {
    baseStyle: {
        opacity: 1,
        borderColor: "gray.200",
    },
};
